import styled from "styled-components";

export const AlertModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 35px;

  font-size: 1.6rem;
  text-align: center;

  span {
    white-space: pre-wrap;
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3px;

  .small {
    width: 40%;
  }
`;

export const Description = styled.span`
  white-space: pre-line; /* \n 을 실제 줄바꿈으로 렌더링 */
  line-height: 1.5;
  display: block;
  font-size: 1.5rem;
`;
